// extracted by mini-css-extract-plugin
module.exports = {"language-switcher":"style_language-switcher__1X62c","active":"style_active__kErfx"};